import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';


@Injectable()
export class ScheduleEventProvider {
    constructor(public http: HttpClient) {
    }
}



// WEBPACK FOOTER //
// ./src/providers/schedule-event/schedule-event.ts